import React, { useContext } from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';
import _reduce from 'lodash/reduce';
import _isEmpty from 'lodash/isEmpty';
import { UserContext } from 'commons-ui';

import { ACL_ENTITIES } from 'constant';
import usePermission from './usePermission';

interface IAuthorizedRouteProps {
	path: any;
	component: any;
	entity?: string;
	actions?: Array<string>;
	configPageName: string;
	exact?: boolean;
}

const AuthorizedRoute: React.FC<IAuthorizedRouteProps> = ({ path, component, entity, actions, exact, configPageName }) => {
	const { isLoggedIn, user } = useContext(UserContext);
	const { hasPermission } = usePermission();

	const history = useHistory();
	// If logged in
	if (!isLoggedIn || _isEmpty(user)) {
		return (
			<Redirect
				to={{
					pathname: '/login',
					state: { referrer: history.location.pathname }
				}}
			/>
		);
	}

	if (entity && ACL_ENTITIES.includes(entity)) {
		// Don't check role based permission incase of ACL entities
		return <Route exact={exact} path={path} component={component} />;
	}

	let permission;
	if (actions) {
		permission = _reduce(actions, (aggregate, action) => aggregate && hasPermission({ entity, action, configPageName }), true);
	} else {
		permission = hasPermission({ configPageName, entity });
	}
	// checking for permission
	if (!permission) {
		return (
			<Redirect
				to={{
					pathname: '/error',
					state: { statusCode: 403, errorMsg: 'You are not authorized to perform this action' }
				}}
			/>
		);
	}
	return <Route exact={exact} path={path} component={component} />;
};

export default AuthorizedRoute;
